var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("p", [
      _c("span", { staticClass: "strong" }, [
        _vm._v(_vm._s(_vm.widget.label || _vm.widget.id))
      ])
    ]),
    _vm._v(" "),
    _c("div", {
      staticClass: "hover-shadow box-border-7",
      domProps: { innerHTML: _vm._s(_vm.widget.parameter) }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-00f51ae8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00f51ae8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/TicketWidgetLiteral.vue
// module id = 874
// module chunks = 75